/* eslint-disable react/react-in-jsx-scope */
import Select from 'react-select';
import { MultiSelectValueContainer, InputOption } from "../elements/MultiSelectCustomComponents"

function MultiSelect({ options, values, onChange, name, placeholder,optionLabel='label',optionValue='value', isDisabled=false, isClearable = true }) {
    return (
        <Select
            isMulti
            name={name}
            options={options}
            placeholder={placeholder}
            value={(options instanceof Array && values && options.filter((e) =>
                [...(values instanceof Array ? values : []),].includes(e[optionValue])
            )) || []
            }
            getOptionLabel={(obj) => obj[optionLabel]}
            getOptionValue={(obj) => obj[optionValue]}
            onChange={(v, event) => onChange(name, v, true,optionValue,optionLabel, event)}
            disabled="disabled"
            isDisabled={isDisabled}
            isReadOnly
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            backspaceRemovesValue={false}
            isClearable={isClearable}
            components={{ ValueContainer: MultiSelectValueContainer, Option: InputOption }}
            className="react-select"
            classNamePrefix="react-select"
            aria-label={`for ${name}`}
        />
    )
}
export default MultiSelect;